import { cva } from 'class-variance-authority'
import classNames from 'classnames'
import React, { forwardRef } from 'react'

type PropTypes = {
  label?: string,
  error?: string,
  containerClassName?: string,
  className?: string,
  variant?: 'default' |  'xxs'
} & React.InputHTMLAttributes<HTMLTextAreaElement>;

const inputStyles = cva(
  [
    'w-full py-3 px-3 peer rounded text-gray-700 text-base leading-6 font-medium placeholder-gray-600 border-gray-400 border outline-none transition-all w-full',
    'focus:ring-2 focus:ring-green-900 focus:border-gray-400',
  ],
  {
    variants: {
      error: {
        true: 'text-red-700 border-red-500',
      },
      variant: {
        default: '',
        xxs: '!py-[5.5px] !text-[14px]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export default forwardRef<HTMLTextAreaElement, PropTypes>(function TextBox ({
  label,
  error,
  containerClassName,
  className,
  variant,
  ...rest
}, ref) {
  return (
    <div className={containerClassName}>
      {label && <label className="text-sm font-medium text-gray-700">{label}</label>}
      <textarea
        ref={ref}
        {...rest}
        className={classNames(
          className,
          inputStyles({
            error: Boolean(error),
            variant,
          }),
        )}
      />
      {error && <p className="text-red-700 text-[13px] leading-[15.6px]">{error}</p>}
    </div>
  )
})
